import React from "react";
import EstimateWizardContainer from "./EstimateWizardContainer.tsx";
import CoverForm from "../../contracts/estimates/CoverForm.tsx";
import EstimateForm from "../../contracts/estimates/EstimateForm.tsx";
import { COMPANY_IN_CHARGE_TYPE, REMARK_JINYOUNG, EstimateDto } from "../../contracts/estimates/types.ts";
import { useEstimateApi } from "../../hooks/useEstimateApi.ts";

export default function EstimateWizard() {
    const { previewCoverPdf, previewContentPdf, previewCoverPdfMun, previewContentPdfMun } = useEstimateApi();

    return (
        <EstimateWizardContainer
            companyInChargeIndex={0}
            defaultValues={{
                content: {
                    remark: REMARK_JINYOUNG
                } as any,
                companyInCharge: COMPANY_IN_CHARGE_TYPE[0]
            }}
            stepsConfig={[
                {
                    label: "표지 정보",
                    render: (props) => <CoverForm {...props} />
                },
                {
                    label: "견적서 본문",
                    render: (props) => <EstimateForm {...props} />
                }
            ]}
            getPreviewBlob={async (data: EstimateDto, activeStep: number) => {
                if (activeStep === 0) {
                    const cover = data.companyInCharge === COMPANY_IN_CHARGE_TYPE[0] 
                        ? await previewCoverPdf(data) 
                        : await previewCoverPdfMun(data);
                    return { cover };
                } else {
                    const content = data.companyInCharge === COMPANY_IN_CHARGE_TYPE[0] 
                        ? await previewContentPdf(data) 
                        : await previewContentPdfMun(data);
                    return { content };
                }
            }}
        />
    );
}
